import { LoadingOutlined } from '@ant-design/icons';
import { Button, Spin } from 'antd';
import React from 'react';

interface ButtonComponentProps {
    label: string;
    disabled?: boolean;
    className?: string;
    loading?: boolean | undefined;
    type?: "link" | "text" | "primary" | "default" | "dashed" | undefined;
    onClick?: () => void; // Adicionando a prop onClick
    style?: any;
    removeSubmit?: boolean;
}

const ButtonComponent: React.FC<ButtonComponentProps> = ({ label = "Confirmar", style, removeSubmit, type, loading, className, disabled, onClick }) => {

    return (
        <Button
            type={type ? type : 'primary'}
            style={{ ...style, boxShadow: "none" }}
            size="large"
            htmlType={removeSubmit ? undefined : "submit"}
            className={`${className}`}
            disabled={disabled}
            onClick={onClick}
        >
            <div className="flex gap-2 items-center text-sm">
                {loading && <Spin style={{ color: "#fff" }} indicator={<LoadingOutlined spin />} size="small" />}
            </div>
            <p>{label}</p>
        </Button>
    );
};

export default ButtonComponent;
